import script from "./TooltipIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./TooltipIcon.vue?vue&type=script&setup=true&lang=js"

import "./TooltipIcon.vue?vue&type=style&index=0&id=89ef219c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/blueshift-vesting-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89ef219c"]])

export default __exports__